
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.728261 3.27916C-0.355786 1.97622 0.570772 0 2.26571 0H17.7343C19.4292 0 20.3558 1.97622 19.2717 3.27916L12.4 11.5385V19C12.4 19.5523 11.9523 20 11.4 20H8.6C8.04772 20 7.6 19.5523 7.6 19V11.5385L0.728261 3.27916Z","fill":"#00A769"}})])
          )
        }
      }
    